import React, { useState } from "react";
import axios from "axios";
import { Mail, Loader2, Check } from "lucide-react";
import { API } from "../../lib/api";

export const TranscriptEmail = ({ sessionId }) => {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setState("sending");
    setError("");
    try {
      await axios.post(`${API}/chat/transcript`, { session_id: sessionId, email: email.trim() });
      setState("sent");
    } catch (err) {
      setError(err?.response?.data?.detail || "Sorry, we couldn't send it. Please try again.");
      setState("idle");
    }
  };

  if (state === "sent") {
    return (
      <p className="px-3 py-2 text-[11px] text-brand-darkgrey bg-white border-t border-border flex items-center gap-1" data-testid="chat-transcript-sent">
        <Check className="h-3.5 w-3.5 text-brand-gold" /> A copy of this chat has been sent to {email.trim()}.
      </p>
    );
  }
  if (!open) {
    return (
      <div className="px-3 py-1.5 bg-white border-t border-border">
        <button type="button" onClick={() => setOpen(true)} data-testid="chat-transcript-open"
          className="text-[11px] text-brand-darkgrey hover:text-brand-gold inline-flex items-center gap-1">
          <Mail className="h-3.5 w-3.5" /> Email me a copy of this chat
        </button>
      </div>
    );
  }
  return (
    <form onSubmit={submit} className="px-3 py-2 bg-white border-t border-border space-y-1.5" data-testid="chat-transcript-form">
      <div className="flex items-center gap-2">
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email address"
          data-testid="chat-transcript-email" className="flex-1 text-xs px-3 py-1.5 border border-border rounded-full focus:outline-none focus:ring-2 focus:ring-brand-gold" />
        <button type="submit" disabled={state === "sending" || !email.trim()} data-testid="chat-transcript-send"
          className="shrink-0 text-xs bg-brand-black text-white px-3 py-1.5 rounded-full hover:bg-brand-gold transition-colors disabled:opacity-50 inline-flex items-center gap-1">
          {state === "sending" && <Loader2 className="h-3 w-3 animate-spin" />} Send
        </button>
        <button type="button" onClick={() => setOpen(false)} data-testid="chat-transcript-cancel" className="text-[11px] text-brand-darkgrey hover:text-brand-black">Cancel</button>
      </div>
      <p className="text-[10px] text-muted-foreground leading-snug">
        Only use an email account that is private to you. If you are worried someone may read your email, you may prefer not to send a copy.
      </p>
      {error && <p className="text-[11px] text-brand-danger" data-testid="chat-transcript-error">{error}</p>}
    </form>
  );
};
